import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-client';
import type { PerDiemEntry } from '@/lib/types';

const PAYROLL_API = '/api/v1/payroll';

export function useRejectPerDiem() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({
      id,
      reason,
    }: {
      id: number;
      reason: string;
    }): Promise<PerDiemEntry> => {
      const response = await apiClient.post<PerDiemEntry>(
        `${PAYROLL_API}/per-diem/${id}/reject/`,
        { reason },
      );
      return response.data;
    },
    onSuccess: (_, { id }) => {
      qc.invalidateQueries({ queryKey: queryKeys.perDiem.all });
      qc.invalidateQueries({ queryKey: queryKeys.perDiem.detail(id) });
    },
  });
}
